// extracted by mini-css-extract-plugin
export var documentation = "_jj-1";
export var menu = "_jj-0";